import MathFilling from "@/components/Math/math-filling";
import { QuestionData } from "../Math/types";
import VisualDiagram from "@/components/visual/VisualDiagram";
import { getQuestionPictureFallback, getQuestionVisual } from "@/lib/visual-diagram";

interface PracticeMathFillingProps {
  question: QuestionData;
  currentAnswer: any;
  allFinished: boolean;
  disabled: boolean;
  // 是否隐藏题目本身，用于example question
  hideQuestion?: boolean;
  triggerCheck?: boolean;

  needButtons?: boolean;

  handleAnswer: (option: string, isCorrect: boolean, autoSubmit?: boolean) => void;
  onInputChange?: (value: string) => void;
}

const PracticeMathFilling: React.FC<PracticeMathFillingProps> = ({ 
  question, 
  handleAnswer, 
  currentAnswer, 
  allFinished, 
  disabled, 
  hideQuestion = false, 
  onInputChange, 
  triggerCheck, 
  needButtons = true 
}) => {
  const questionVisual = getQuestionVisual(question);
  const questionPictureFallback = getQuestionPictureFallback(question);

  // 确定答案状态
  const getAnswerState = () => {
    if (currentAnswer.selectedOption === null) return "none";
    return currentAnswer.isCorrect ? "correct" : "incorrect";
  };

  return (
    <div className="w-full">
      {questionVisual && (
        <VisualDiagram
          visual={questionVisual}
          picture={questionPictureFallback}
          pictureAlt="Question diagram"
          context={typeof question?.question === 'string' ? question.question : ''}
        />
      )}
      <MathFilling
        question={question}
        userAnswer={currentAnswer.selectedOption || ""}
        answerState={getAnswerState()}
        readonly={disabled || allFinished || currentAnswer.selectedOption !== null}
        hideQuestion={hideQuestion}
        needButtons={needButtons}
        showExplanation={true}
        onAnswer={handleAnswer}
        onInputChange={onInputChange}
        triggerCheck={triggerCheck}
      />
    </div>
  );
}

export default PracticeMathFilling;
